import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import FontFaceObserver from "fontfaceobserver";
import analytics from "web/script/analytics/analytics";
import cookie from "web/script/utils/cookie";
var FONT_LOAD_TIMEOUT = 5000; // 5s

var FONT_TEST_CHARS = "BESbswy"; // TODO: i18n?

var FONT_CLASSNAME = "fonts-pending";
var LYST_FONTS = [["Brown", {
  weight: "normal",
  style: "normal"
}], ["Brown", {
  weight: "bold",
  style: "normal"
}], ["IBM Plex Sans", {
  weight: "normal",
  style: "normal"
}], ["IBM Plex Sans", {
  weight: 300,
  style: "normal"
}], ["Sang Bleu Empire", {
  weight: "normal",
  style: "normal"
}]];

function namify(name, args) {
  if (args.weight == "bold") {
    name += " Bold";
  } else if (args.weight == 300) {
    name += " Light";
  }

  if (args.style == "italic") {
    name += " Italic";
  }
}

function createObserver(_x, _x2) {
  return _createObserver.apply(this, arguments);
}

function _createObserver() {
  _createObserver = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(name, args) {
    var observer, fancyName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            observer = new FontFaceObserver(name, args);
            _context.prev = 1;
            _context.next = 4;
            return observer.load(FONT_TEST_CHARS, FONT_LOAD_TIMEOUT);

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            // TODO: This causes failed font loads to appear to be successful ones.
            //       I don't think this is what we want
            fancyName = namify(name, args);
            console.error("Custom font", fancyName, "did not load within 5 seconds.");
            analytics.event("fonts", "failed", fancyName, true);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));
  return _createObserver.apply(this, arguments);
}

function loadFonts() {
  return _loadFonts.apply(this, arguments);
}

function _loadFonts() {
  _loadFonts = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var documentClasses, observers;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            documentClasses = document.documentElement.classList; // Check to see if the magic cookie is set and we can let fonts load normally

            if (documentClasses.contains(FONT_CLASSNAME)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            observers = LYST_FONTS.map(function (args) {
              return createObserver.apply(void 0, _toConsumableArray(args));
            });
            _context2.next = 6;
            return Promise.all(observers);

          case 6:
            // The user has "successfully" loaded all fonts, let's avoid giving them the
            // fallback next time
            cookie("withfonts", "1", {
              path: "/"
            });
            documentClasses.remove(FONT_CLASSNAME);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadFonts.apply(this, arguments);
}

export default loadFonts;